export default __webpack_public_path__ + "static/media/forward_thin_fff.2a89d54c.svg";